/* eslint-disable */
require('./Alert')
require('./All-App')
require('./Arrow-Up')
require('./Bell')
require('./BellMinus')
require('./BellPlus')
require('./Calendar')
require('./Caret-Down')
require('./Caret-Up')
require('./Check')
require('./Checked')
require('./Clip')
require('./Clock')
require('./Companies')
require('./Compare')
require('./ControlHover')
require('./ControlRadioCheck')
require('./ControlRound')
require('./Copy')
require('./Crown-Bronze')
require('./Crown-Gold')
require('./Crown-Silver')
require('./Crown')
require('./Delete')
require('./Display')
require('./Dots')
require('./Down-Arrow')
require('./Down')
require('./DownArrow_fill')
require('./Edit')
require('./Gear')
require('./Graph-Alt')
require('./Graph')
require('./Help')
require('./Hint')
require('./Home')
require('./Left-Arrow')
require('./List')
require('./Lock')
require('./Loupe')
require('./MailAdd')
require('./MailAdded')
require('./Minus')
require('./Multiply')
require('./No-Image')
require('./Note')
require('./Pen')
require('./Plus_alt')
require('./Plus')
require('./Refresh')
require('./renewal')
require('./Review')
require('./Right-Arrow')
require('./RightArrow_fill')
require('./Round')
require('./Sort')
require('./Spin-Alt')
require('./Spin')
require('./Star-Empty')
require('./Star-Filled')
require('./Star-Half')
require('./Student')
require('./Three-Dots')
require('./Trash')
require('./Unchecked-Disabled')
require('./Unchecked-Hover')
require('./Unchecked')
require('./University')
require('./Up')
